import { render, staticRenderFns } from "./FullScreenSpinner.vue?vue&type=template&id=61961c10&scoped=true&"
import script from "./FullScreenSpinner.vue?vue&type=script&lang=js&"
export * from "./FullScreenSpinner.vue?vue&type=script&lang=js&"
import style0 from "./FullScreenSpinner.vue?vue&type=style&index=0&id=61961c10&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61961c10",
  null
  
)

export default component.exports